import React from 'react'
import styles from './styles.module.scss'
import SvgBag from '@/src/assets/svgs/collection/bag-no-items.svg'
import SvgPaper from '@/src/assets/svgs/collection/paper-no-items.svg'
import SvgCoupon from '@/src/assets/svgs/collection/coupon-no-items.svg'
import SvgStar from '@/src/assets/svgs/collection/star-no-items.svg'
import SvgPromotion from '@/src/assets/svgs/collection/promotion-no-items.svg'

interface Props {
    type: 'bag' | 'paper' | 'coupon' | 'star' | 'promotion'
    message: string
    imageSize?: string
}

export default function NoItems(props: Props) {
    const getIcon = () => {
        if (props.type === 'bag')
            return <SvgBag />

        if (props.type === 'paper')
            return <SvgPaper />

        if (props.type === 'star')
            return <SvgStar />

        if (props.type === 'promotion')
            return <SvgPromotion />

        return <SvgCoupon />
    }

    return (
        <div className={styles.container}>
            <div className={styles.image} style={props.imageSize ? { width: props.imageSize, height: props.imageSize } : {}}>
                {getIcon()}
            </div>
            <p>{props.message}</p>
        </div>
    )
}
